<template>
  <div class="wheel-battle-detail-page">
    <van-sticky>
      <div class="wheel-battle-sticky-head">
        <wheel-battle-consumer-header
          :banner="matchBanner"
          :header="header"
          :union-match-id="unionMatchId"
        />
        <van-tabs v-model="activeTab" class="detail-tabs detail-tabs--head-only">
          <van-tab title="对战" name="match" />
          <van-tab title="排名" name="rank" />
        </van-tabs>
      </div>
    </van-sticky>

    <wheel-battle-consumer-match-tab
      v-show="activeTab === 'match'"
      :waiting-teams="waitingTeams"
      :match-list="matchList"
      :match-logo="matchLogo"
    />
    <wheel-battle-consumer-rank-tab
      v-show="activeTab === 'rank'"
      :standing="standing"
      :match-logo="matchLogo"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabs, Tab, Toast, Sticky } from 'vant'
Vue.use(Tabs).use(Tab).use(Toast).use(Sticky)

import { getBMGameDetail } from '@/api/match'
import { getBMMatchWheelBattleParentGame } from '@/api/wheel-battle'
import { QNImageUtil } from '@/utils'
import { wheelBattleConsumerStateFromApiDetail } from './wheel-battle-utils'
import WheelBattleConsumerHeader from './components/wheel-battle/WheelBattleConsumerHeader.vue'
import WheelBattleConsumerMatchTab from './components/wheel-battle/WheelBattleConsumerMatchTab.vue'
import WheelBattleConsumerRankTab from './components/wheel-battle/WheelBattleConsumerRankTab.vue'

var POLL_INTERVAL_MS = 5000

export default {
  name: 'NewGameDetailWheelBattle',
  components: {
    WheelBattleConsumerHeader,
    WheelBattleConsumerMatchTab,
    WheelBattleConsumerRankTab
  },
  data: function () {
    return {
      gameId: '',
      unionMatchId: '',
      activeTab: 'match',
      matchBanner: {},
      matchLogo: '',
      header: {},
      waitingTeams: [],
      matchList: [],
      standing: [],
      parentGameState: null,
      pollTimer: null,
      matchInfoCache: null
    }
  },
  computed: {
    isParentEnded: function () {
      return Number(this.parentGameState) === 2
    }
  },
  mounted: function () {
    this.gameId = this.$route.params.gameId || ''
    this.loadDetail(false)
  },
  activated: function () {
    if (this.gameId) {
      this.loadDetail(false)
    }
  },
  deactivated: function () {
    this.stopPolling()
  },
  beforeDestroy: function () {
    this.stopPolling()
  },
  methods: {
    loadDetail: function (silent) {
      var self = this
      var requests = [
        getBMMatchWheelBattleParentGame({ gameId: this.gameId })
      ]
      if (!silent || !this.matchInfoCache) {
        requests.push(getBMGameDetail({ gameId: this.gameId }))
      }
      return Promise.all(requests).then(function (results) {
        var detailRes = results[0]
        var gameRes = results[1]
        if (detailRes && detailRes.error) {
          if (!silent) {
            Toast(detailRes.msg || '加载失败')
          }
          return
        }
        if (gameRes && gameRes.data) {
          self.matchInfoCache = self.buildMatchInfo(gameRes.data)
        }
        var page = wheelBattleConsumerStateFromApiDetail(
          detailRes && detailRes.data,
          self.matchInfoCache
        )
        if (!page) {
          if (!silent) {
            Toast('加载失败')
          }
          return
        }
        self.applyPageState(page)
      }).catch(function () {
        if (!silent) {
          Toast('加载失败')
        }
      })
    },
    pollDetail: function () {
      if (this.isParentEnded) {
        this.stopPolling()
        return
      }
      this.loadDetail(true)
    },
    startPolling: function () {
      this.stopPolling()
      if (this.isParentEnded) {
        return
      }
      var self = this
      this.pollTimer = setInterval(function () {
        self.pollDetail()
      }, POLL_INTERVAL_MS)
    },
    stopPolling: function () {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    buildMatchInfo: function (data) {
      var game = (data && data.game) || {}
      var chineseName = game.match && game.match.chineseName != null
        ? String(game.match.chineseName)
        : ''
      var nameParts = chineseName.split('_')
      this.unionMatchId = game.unionMatchId != null ? String(game.unionMatchId) : ''
      return {
        name: nameParts[0] || '',
        groupStage: [nameParts[1], game.roundDescription].filter(Boolean).join(' ').trim(),
        icon: game.match && game.match.icon ? QNImageUtil.imageView(game.match.icon) : ''
      }
    },
    applyPageState: function (page) {
      this.matchBanner = page.matchBanner || {}
      this.matchLogo = (page.matchBanner && page.matchBanner.icon) || ''
      this.header = page.header || {}
      this.waitingTeams = page.waitingTeams || []
      this.matchList = page.matchList || []
      this.standing = page.standing || []
      this.parentGameState = page.parentGame && page.parentGame.state
      if (this.isParentEnded) {
        this.stopPolling()
      } else {
        this.startPolling()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-detail-page {
  min-height: 100vh;
  background: #f6f6f8;
}

.wheel-battle-sticky-head {
  background: linear-gradient(180deg, #e3eaf1 0%, #f8fbff 55%, #eceef0 100%);
}

.detail-tabs {
  ::v-deep .van-tabs__wrap {
    background: #eceef0;
    border-bottom: 1px solid #e4e6e8;
  }

  ::v-deep .van-tabs__nav {
    background: #eceef0;
  }

  ::v-deep .van-tabs__nav--line {
    padding-bottom: 0;
    padding-left: 16px;
    box-sizing: border-box;
  }

  ::v-deep .van-tab {
    flex: none;
    padding: 0;
    margin-right: 30px;
    font-size: 15px;
    color: #73767a;
  }

  ::v-deep .van-tab:last-child {
    margin-right: 0;
  }

  ::v-deep .van-tab--active {
    color: #1d2129;
    font-weight: 600;
  }

  ::v-deep .van-tabs__line {
    background: #337ecc;
    height: 3px;
    border-radius: 2px;
    bottom: 0;
  }
}

.detail-tabs--head-only {
  ::v-deep .van-tabs__content {
    display: none;
  }
}
</style>
